import errorMessages from './errorsMessages'

export const errorMessageGenerator = (model, fieldName) => {
  if (!model || !model.$dirty) return []
  const keys = Object.keys(model).filter(i => !i.includes('$'))
  return keys
    .map(key => !model[key] && errorMessages[fieldName] && errorMessages[fieldName][key])
    .filter(i => i)
}

export * from './company'
export * from './contract'
export * from './document'
export * from './payment'
export * from './variation'
export * from './dictionaries'
export * from './risks'
export * from './guarantee'
export * from './liquidatedDamages'
